export default __webpack_public_path__ + "static/rocket_on_stick-36498efea861c36fc54b201fb45f5cab.png";